/* eslint-disable
    no-restricted-properties,
*/
angular.module('unergie.main')
.factory('MS', () => {
    const round = function (number, precision) {
        const factor = Math.pow(10, precision !== undefined ? precision : 2)
        return Math.round(number * factor) / factor
    }

    return {
        round,
    }
})
